// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"rates_table_tableContainer__33Q0Z"};